import { withEditableInput } from '@trendkite/ui';
import StoryHeadlineDisplay from './StoryHeadlineDisplay';
import StoryHeadlineWrapper from './StoryHeadlineWrapper';

export default withEditableInput(StoryHeadlineDisplay, StoryHeadlineWrapper);
